import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Hook to check maintenance mode status in real-time.
 * Listens to Firestore `config/maintenance` document.
 * Returns { isMaintenanceMode, maintenanceMessage, estimatedTime, loading }
 */
export const useMaintenance = () => {
    const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
    const [maintenanceMessage, setMaintenanceMessage] = useState('');
    const [estimatedTime, setEstimatedTime] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Real-time listener for maintenance status
        const unsubscribe = onSnapshot(
            doc(db, 'config', 'maintenance'),
            (docSnapshot) => {
                if (docSnapshot.exists()) {
                    const data = docSnapshot.data();

                    // Bypass maintenance mode if we are on localhost
                    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

                    if (isLocalhost) {
                        setIsMaintenanceMode(false);
                    } else {
                        setIsMaintenanceMode(data.enabled === true);
                    }

                    setMaintenanceMessage(data.message || '');
                    setEstimatedTime(data.estimatedTime || '');
                } else {
                    // Document doesn't exist yet - maintenance is OFF
                    setIsMaintenanceMode(false);
                    setMaintenanceMessage('');
                    setEstimatedTime('');
                }
                setLoading(false);
            },
            (error) => {
                console.error('Error listening to maintenance status:', error);
                // On error, default to NOT maintenance mode (don't block users)
                setIsMaintenanceMode(false);
                setLoading(false);
            }
        );

        return () => unsubscribe();
    }, []);

    return { isMaintenanceMode, maintenanceMessage, estimatedTime, loading };
};
